import script from "./LucaDocumentItem.vue?vue&type=script&setup=true&lang=js"
export * from "./LucaDocumentItem.vue?vue&type=script&setup=true&lang=js"

import "./LucaDocumentItem.vue?vue&type=style&index=0&id=4fde2e4b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fde2e4b"]])

export default __exports__